import { RESET_STATE } from 'store/global/actions';

import { OB_CONFIG_ACTION_TYPE } from '../actions';

const initialState = {
  accounts: [],
  accountStrategies: {},
  configuration: {},
};

const obConfigReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case OB_CONFIG_ACTION_TYPE.GET_OB_ACCOUNTS:
      return { ...state, accounts: payload };

    case OB_CONFIG_ACTION_TYPE.GET_OB_ACCOUNT_STRATEGY:
      return {
        ...state,
        accountStrategies: {
          ...state.accountStrategies,
          [payload.companyId]: {
            ...state.accountStrategies[payload.companyId],
            [payload.accountId]: payload.strategy,
          },
        },
      };

    case OB_CONFIG_ACTION_TYPE.GET_CONFIGURATION:
    case OB_CONFIG_ACTION_TYPE.EDIT_CONFIGURATION:
      return { ...state, configuration: payload };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default obConfigReducer;
